export default __webpack_public_path__ + "static/media/partners5.9837605f.jpg";